export default "__VITE_ASSET__Cc1700I2__"